export default __webpack_public_path__ + "static/media/red360.7c9dfacc.gif";